import React from "react";
import StatusIndicator from "../shared/StatusIndicator";

/**
 * Initial-load spinner. Mirrors monolith lines 1170–1178.
 */
export const LoadingState: React.FC<{ message?: string; phase?: string }> = ({ message, phase }) => (
  <div
    className="spinner-container"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "300px",
    }}
  >
    <StatusIndicator status="loading" overlay={false} message={message} phase={phase} />
  </div>
);

export default LoadingState;
